import BoxWraper from "../account/box-wrapper";
import ErrorText from "./error-text";

export const ErrorFallback = <BoxWraper width={5}>
  <ErrorText>An error has occured. Please try refreshing the page. The developers have been notified of the error.
    If the error continues to occur, then please email <a href="mailto:contact@filmanize.com">contact@filmanize.com</a>, or post in the #bugs channel on <a href="https://discord.com/invite/4G4E87Y5E4" target="_blank">Discord</a>
  </ErrorText>
</BoxWraper>